module.exports = __webpack_public_path__ + "assets/img/6.df9c8eb4.jpg";